import { createFileRoute } from '@tanstack/react-router'
import { AdministrarPlantillasScreen } from '@web/app/features/firmas/'
import { LayoutTemplate } from '@tamagui/lucide-icons'

export const Route = createFileRoute('/_index/documents/templates')({
  component: AdministrarPlantillasScreen,
  staticData: {
    metaRoute: {
      title: 'Plantillas',
      order: 1,
      icon: LayoutTemplate,
    },
  },
})
